import {AfterViewInit, Component, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import {AuthService} from "./pages/login/services/auth.service";
import {ParameterService} from "./_services/parameter.service";
import {ProfileMessage} from "./_services/profile.message";
import {JwtHelperService} from "@auth0/angular-jwt";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit, AfterViewInit{
  user: any;
  maintenanceFlag = 2;
  constructor(
    private authService: AuthService,
    private router: Router,
    private parameterService: ParameterService,
    private profileMsg: ProfileMessage,
    private jwtHelper: JwtHelperService,
  ) {}

  async ngOnInit(): Promise<void> {
    this.parameterService.getMaintenanceMode().then(parameter => {
      this.maintenanceFlag = parameter.parameterMembers[0].parameterValue;
      this.updateProfile();
    }, error => {
      console.log('called this error');
      console.log(error);
    })
  }

  ngAfterViewInit() {
    if(this.jwtHelper.isTokenExpired()) {
      localStorage.clear();
    }
  }

  login(): void {
    this.router.navigateByUrl('/login').then();
  }

  register(): void {
    this.router.navigateByUrl('/register').then();
  }

  updateProfile() {
    this.authService.profile().then((res) => {
      this.profileMsg.changeMessage(res);
    },(_) => {
      localStorage.clear();
    });
  }
}
